import React, { useEffect } from "react";
import "../../styles/SuccessMessage.css";

const SuccessMessage = ({ message, isError, onClose, duration = 3000 }) => {
  useEffect(() => {
    // Set a timer to automatically close the message after a given duration
    const timer = setTimeout(onClose, duration);

    // Clear the timer if the component is unmounted or if the timer is not needed
    return () => clearTimeout(timer);
  }, [onClose, duration]);

  return (
    <div
      className={`fixed inset-0 flex items-center justify-center z-50 ${
        isError ? "error-bg" : "success-bg"
      }`}
    >
      <div
        className={`bg-white rounded-lg shadow-lg p-6 transform transition-transform duration-300 ${
          isError ? "shake-animation" : "scale-animation"
        }`}
      >
        <div className="flex items-center space-x-4">
          <div className="flex-shrink-0">
            {isError ? (
              <svg
                className="w-12 h-12 text-red-500"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            ) : (
              <svg
                className="w-12 h-12 text-green-500"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            )}
          </div>
          <div>
            <h2 className="text-sm font-semibold text-gray-800">{message}</h2>
          </div>
        </div>
        <button
          onClick={onClose}
          className="mt-4 px-4 py-2 bg-blue-500 text-white rounded-lg shadow-lg transform transition-transform duration-300 hover:scale-105 focus:scale-95 focus:outline-none"
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default SuccessMessage;
